// Copyright 2026, compose-coui-ui contributors
// SPDX-License-Identifier: Apache-2.0

package io.github.suqi8.coui.kmp.icon

object COUIIcons {
    object Basic
    object Light
    object Normal
    object Regular
    object Medium
    object Demibold
}
